import { render, staticRenderFns } from "./TheDefaultModal.vue?vue&type=template&id=0f87dc4c"
import script from "./TheDefaultModal.vue?vue&type=script&lang=js"
export * from "./TheDefaultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports